import { X, CalendarCheck } from "lucide-react";
import { workDatesLabel } from "@/lib/dates";

// Last look before a slip goes out — catches accidental date taps.
export default function ConfirmDatesModal({ open, who, terms, action = "Send offer", busy, onConfirm, onClose }) {
  if (!open) return null;
  const dates = terms.flexible ? [] : (terms.work_dates?.length ? terms.work_dates : [terms.start_date]).filter(Boolean);
  const label = workDatesLabel({ ...terms, work_dates: dates });
  return (
    <div className="fixed inset-0 z-[90] bg-black/85 flex items-end sm:items-center justify-center p-0 sm:p-4" data-testid="confirm-dates-modal">
      <div className="w-full max-w-md bg-[#111] border border-white/15 p-6 relative">
        <button onClick={onClose} className="absolute top-3 right-3 text-red-500 hover:text-red-400" aria-label="Close" data-testid="confirm-dates-close"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 font-bold uppercase tracking-widest text-xs" style={{ color: "#FF6A00" }}><CalendarCheck className="w-4 h-4" /> Double-check the dates</div>
        <p className="mt-3 text-base" style={{ color: "#fff" }} data-testid="confirm-dates-text">
          {who ? <>You want to book <b>{who}</b> for</> : <>You're posting <b>{terms.title || "this job"}</b> for</>}
        </p>
        <div className="mt-2 border-l-4 pl-3 py-1" style={{ borderColor: "#16A34A" }}>
          <div className="font-display font-black text-xl uppercase tracking-tight" style={{ color: "#fff" }} data-testid="confirm-dates-label">{label}</div>
          {dates.length > 1 && (
            <ul className="mt-1 text-sm space-y-0.5" style={{ color: "#D4D4D8" }} data-testid="confirm-dates-list">
              {dates.map((d) => <li key={d}>{new Date(d + "T12:00:00").toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short", year: "numeric" })}</li>)}
            </ul>
          )}
          {terms.flexible && <div className="text-sm" style={{ color: "#D4D4D8" }}>Flexible — the tradie proposes days inside that window.</div>}
        </div>
        <div className="mt-5 flex gap-3">
          <button onClick={onClose} disabled={busy} style={{ color: "#D4D4D8" }} className="flex-1 px-3 py-3 border border-white/20 text-xs font-bold uppercase tracking-widest hover:border-white" data-testid="confirm-dates-cancel">Go back</button>
          <button onClick={onConfirm} disabled={busy} className="flex-1 px-3 py-3 bg-[#16A34A] text-black text-xs font-black uppercase tracking-widest hover:bg-white disabled:opacity-50" data-testid="confirm-dates-confirm">{busy ? "Sending…" : `Yes — ${action}`}</button>
        </div>
      </div>
    </div>
  );
}
